import { ProductBlock } from "./product-block";

export class ProductConfigureBlock extends ProductBlock {
    public static CLASS_NAME = "product-configurator-block";

    private radioBtnsStrain: JQuery;
    private radioBtnsAge: JQuery;

    private numberValue: JQuery;
    private resultText: JQuery;

    private currStrain: number;
    private currAge: number;

    private currValue: string;

    constructor(e: HTMLElement) {
        super(e);

        this.currStrain = 0;
        this.currAge = 0;

        this.radioBtnsStrain = $("#radio-strain input", this.element);
        this.radioBtnsAge = $("#radio-age input", this.element);

        this.numberValue = $(".number .value", this.element);

        this.resultText = $(".result-text", this.element);

        this.radioBtnsStrain.change((e) => {
            this.currStrain = parseInt($(e.currentTarget).val().toString(), null);
            this.updateConfigurator();
        });

        this.radioBtnsAge.change((e) => {
            this.currAge = parseInt($(e.currentTarget).val().toString(), null);
            this.updateConfigurator(); 
        });

        this.updateConfigurator();
    }

    private updateConfigurator() {
        let tot = this.currStrain + this.currAge;
        let number: string;
        let result = "";

        switch (tot) {
            case 0:
            case 1:
                number = "05";
                result = this.resultText.data("result-1");
                break;
            case 2:
            case 3:
                number = "07";
                result = this.resultText.data("result-2");
                break;
            case 4:
            case 5:
                number = "10";
                result = this.resultText.data("result-3");
                break;
            default:
                number = "12";
                result = this.resultText.data("result-4");
                break;
        }
        
        this.numberValue.text(number);

        if (this.currValue !== number) {
            this.currValue = number;

            this.resultText.fadeOut(() => {
                this.resultText.text(result).fadeIn();
            });
        }        
    }

    protected activate() {
        super.activate();

        let $body = $("body");
        $body.removeClass("sticky-footer-hide");
        $body.addClass("sticky-footer-enabled");
    }
}